import { useState } from 'react'
import { ConnectionStatus } from '@/constants/ConnectionStatus'
import axios from 'axios'

const useAPIConnection = () => {
  // #region フック

  const [status, setStatus] = useState<number>(ConnectionStatus.READY)

  const [content, setContent] = useState<object>({})

  const [errors, setErrors] = useState<object[]>([])

  // #endregion フック

  const fetchAPIData = async (url: string) => {
    setStatus(ConnectionStatus.CONNECTING)

    try {
      const res = await axios.get(url)

      if (res.data.content) {
        setContent(res.data.content)
      }
      if (res.data.errors) {
        setErrors(res.data.errors)
      }
    } catch (e) {
      setContent({})
      if (axios.isAxiosError(e) && e.response) {
        setErrors([
          {
            title: 'Server Error',
            message: e.message
          }
        ])
      }
    } finally {
      setStatus(ConnectionStatus.FINISHED)
    }
  }

  const clear = () => {
    setContent({})
    setErrors([])
    setStatus(ConnectionStatus.READY)
  }

  return { status, content, errors, fetchAPIData, clear }
}

export { useAPIConnection }
